import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link, useParams } from "react-router-dom";
import { getContractBySlug } from "../content/contractsRegistry.js";
import NotFoundPage from "./NotFoundPage.jsx";

const PLACEHOLDER_LEGEND = [
  "[CLIENT_NAME]",
  "[EFFECTIVE_DATE]",
  "[SOW_ID]",
  "…and all other bracketed tokens in each document.",
];

export default function ContractTemplatePage() {
  const { slug } = useParams();
  const contract = slug ? getContractBySlug(slug) : null;

  if (!contract) {
    return <NotFoundPage />;
  }

  return (
    <article className="site-page site-page--contract">
      <div className="site-page__inner site-page__inner--contract">
        <aside className="disclaimer-banner" role="note">
          <strong>Legal disclaimer.</strong>
          {" "}
          This document is a non-final draft for discussion. It does not constitute
          legal advice. Consult a qualified attorney licensed in your jurisdiction before
          execution.
        </aside>

        <div className="contract-toolbar no-print">
          <button type="button" className="site-button-primary" onClick={() => window.print()}>
            Print / Save as PDF
          </button>
          <Link to="/contracts" className="site-button-ghost">
            All templates
          </Link>
          <Link to="/pricing" className="site-button-ghost">
            Pricing overview
          </Link>
        </div>

        <section className="fill-in-legend no-print">
          <h2>Placeholder legend</h2>
          <p>
            Replace bracketed tokens (examples below) before sharing externally:
          </p>
          <ul className="site-page__list">
            {PLACEHOLDER_LEGEND.map((item) => (
              <li key={item}>
                <code>{item}</code>
              </li>
            ))}
          </ul>
        </section>

        <div className="contract-prose">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {contract.body}
          </ReactMarkdown>
        </div>

        <p className="site-page__muted no-print">
          <Link to="/contracts">← All templates</Link>
        </p>
      </div>
    </article>
  );
}
